// extracted by mini-css-extract-plugin
export default {"heading_section":"postAddHeading_heading_section__iOkLt"};